// extracted by mini-css-extract-plugin
export default {"processCentricView":"ProcessCentricView_processCentricView__BPEsk"};